/**
 * Sets up the router that is used in View mode. When the site is loaded in
 * CMS editing mode, the whole page is always reloaded and the router only gets
 * the current page. The router will not be used for navigating between pages.
 */

import Vue from 'vue';
import Router from 'vue-router';
import store from '@/Scripts/store';
import { UPDATE_MODEL_BY_URL } from '@/Scripts/store/modules/epiDataModel';
import { CLOSE_MENU, ENABLE_SCROLLING, RESET_RELOADPAGE } from '@/Scripts/store/modules/appContext';
import PageComponentSelector from '@/Scripts/components/PageComponentSelector.vue';

Vue.use(Router);
const router = new Router({
    // Use the HTML HistoryAPI so the # isn't needed in the URL, and
    // Vue routing will work even when going directly to a URL.
    mode: 'history',

    routes: [
        {
            path: '*',
            component: PageComponentSelector
        }
    ],
    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash, behavior: 'smooth' };
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach(async (to, from, next) => {
    // URL is updated by vue-route-sync, and when time travelling with the
    // debugger we don't want to trigger a model commit as the model is already
    // part of the store holding the url update.
    if (store.state.epiDataModel.model.url !== to.fullPath) {
        await store.dispatch(UPDATE_MODEL_BY_URL, to.fullPath);
    }

    next();
});

router.afterEach((to, from) => {
    store.commit(CLOSE_MENU);
    store.commit(ENABLE_SCROLLING);
    store.commit(RESET_RELOADPAGE, {
        to: to.fullPath,
        from: from.fullPath
    });
});

export default router;
